import { INVALIDATE_TELEMETRY, STORE_TELEMETRY } from '../actions/actionTypes';

export const telemetryReducer = (state = {}, action) => {
  switch (action.type) {
    case INVALIDATE_TELEMETRY: {
      const newState = { ...state };
      action.payload.machines.forEach((machineId) => {
        newState[machineId] = {
          allIds: {},
          byId: [],
          isPending: true,
        };
      });

      return newState;
    }

    case STORE_TELEMETRY: {
      const { telemetry } = action.payload;

      const newState = { ...state };
      Object.keys(telemetry).forEach((machineId) => {
        newState[machineId] = {
          allIds: telemetry[machineId].result,
          byId: telemetry[machineId].entities.telemetry || {},
          isPending: false,
        };
      });

      return newState;
    }

    default:
      return state;
  }
};

export default telemetryReducer;



// WEBPACK FOOTER //
// ./src/reducers/telemetry.js